import { FC, useContext } from "react";
import DataTable from "../../../../../shared/components/dataTable";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";
import { Skill } from "../../../../../shared/interfaces/skill";

const SkillList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/skill", {
    params: {
      ...payload,
    },
  });

  const skillData = data as any;

  const navigateToDetails = () => {
    navigate("/master-datas/skills/create");
  };

  const skillDisplayColumns = ["title", "industry", "enabled"];
  let skillList: Skill[] = [];

  skillList = skillData?.items?.map((skill: any) => {
    return {
      id: skill.id,
      title: skill?.name,
      industry: skill?.industry?.name,
      enabled: skill?.enabled,
    };
  });

  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Skills",
    headerTitle: "Skills",
    buttonTitle: "Create",
    titleBarNodes: (skillData?.totalItems || payload.search) && titleBarNode,
    onClick: navigateToDetails,
    disabled: skillData?.entityPermissions
      ? !skillData?.entityPermissions?.includes("Skill-Create")
      : false,
    subHeading: "",
    rowCount: skillData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Skill"
          data={skillList}
          displayColumns={skillDisplayColumns}
          linkColumn="name"
          linkUrl="/master-datas/skills"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={skillData?.totalItems}
          deleteApiUrl="/skill"
          refetchFunction={fetchData}
          disabled={
            skillData?.entityPermissions
              ? !skillData?.entityPermissions?.includes("Skill-Delete")
              : false
          }
        />
      )}
    </TableViewContainer>
  );
};

export default SkillList;
